import { Component, OnInit } from '@angular/core';
import { PaymentModel, MonthOrYearModel, CartItemsModel } from '../../core/models/ShoppingCart.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ShoppingService } from '../../core/services/shopping.service';
import { Router, ActivatedRoute } from '@angular/router';
import { validateConfig } from '@angular/router/src/config';
import { HelperService } from '../../core/services/helper.service';
import { CartItemsComponent } from '../cart-items/cart-items.component';
import { appMessages, appVariables } from '../../core/constants/Common.constant';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  paymentForm: FormGroup;
  PaymentModel: PaymentModel;
  MonthList: MonthOrYearModel[];
  YearList: MonthOrYearModel[];
  NumberPattern: RegExp;
  Errors = [];
  CartItemsList = [];
  private CurrentDate;
  ShowError: boolean;
  IsValidCardNumber: boolean;
  IsValidSecurityCode: boolean;
  IsValidName: boolean;

  constructor(private shoppingService: ShoppingService,
    private helperService: HelperService
    , private router: Router, private route: ActivatedRoute) {
    this.PaymentModel = new PaymentModel();
  }

  ngOnInit() {
    this.IsValidName = true;
    this.IsValidCardNumber = true;
    this.IsValidSecurityCode = true;
    this.shoppingService.IsLoggedIn.emit(true);

    this.NumberPattern = /^[0-9]+$/;
    // this.MonthList = this.shoppingService.MonthList;
    // this.YearList = this.shoppingService.YearList;
    this.initForm();
    this.shoppingService.observePayment.subscribe(payment => {
      this.PaymentModel = payment;
      this.MonthList = this.PaymentModel.ExpirationDateMonthList_ForAPI;
      this.YearList = this.PaymentModel.ExpirationDateYearList_ForAPI;
      this.initForm();
    });

    this.shoppingService.observeCartItems.subscribe(cartItemsList => {
      this.CartItemsList = cartItemsList;
      this.CheckFormData();
    });
  }

  CheckFormData() {
    if (this.paymentForm.controls['Name'].value === null || this.paymentForm.controls['Name'].value === "" ||
      this.paymentForm.controls['CreditCardNumber'].value === null || this.paymentForm.controls['CreditCardNumber'].value === "" ||
      this.paymentForm.controls['SecurityCode'].value === null || this.paymentForm.controls['SecurityCode'].value === "" ||
      this.paymentForm.controls['SelectedExpirationDateMonth'].value === null || this.paymentForm.controls['SelectedExpirationDateMonth'].value === "" ||
      this.paymentForm.controls['SelectedExpirationDateYear'].value === null || this.paymentForm.controls['SelectedExpirationDateYear'].value === ""
    ) {
      return this.ShowError = true;
    }
    else {
      return this.ShowError = false;
    }
  }

  OnValidateFormsFields(data) {
    this.ShowError = (data.length === 0) ? this.ShowError = true : ((this.CheckFormData() === true) ? this.ShowError = true : this.ShowError = false);
  }

  private initForm() {

    this.paymentForm = new FormGroup({
      // tslint:disable-next-line:max-line-length
      'Name': new FormControl(this.PaymentModel.Name, [Validators.maxLength(100), Validators.pattern('')
      ]),
      'CreditCardNumber': new FormControl(this.PaymentModel.CreditCardNumber
        // tslint:disable-next-line:max-line-length
        // ,  Validators.pattern(/^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)
      ),
      'SecurityCode': new FormControl(this.PaymentModel.SecurityCode, [
        Validators.pattern(this.NumberPattern)]),
      'SelectedExpirationDateMonth': new FormControl(null),
      'SelectedExpirationDateYear': new FormControl(null),
    });
  }


  ValidateName() {
    this.IsValidName = true;
    if (this.helperService.validateCreditCardName(this.paymentForm.controls['Name'].value)) {
      this.IsValidName = true;
      return true;
    }
    else {
      this.IsValidName = false;
      return false;
    }
  }
  onFocusOutValidateName($event: any) {
    this.IsValidName = true;
    if (!this.helperService.validateCreditCardName($event.target.value)) {
      // this.paymentForm.controls['Name'].setValue(null); //@toDo- if need to blank the data
      this.IsValidName = false;
    }
  }
  ValidateCardNumber() {
    if (this.paymentForm.controls['CreditCardNumber'].value.match(/[0-9]{15,16}/)) {
      this.IsValidCardNumber = true;
      return true;
    }
    else {
      this.IsValidCardNumber = false;
      return false;
    }
  }
  ValidateSecurityCode() {
    if (this.paymentForm.controls['SecurityCode'].value.match(/[0-9]{3,4}/)) {
      this.IsValidSecurityCode = true;
      return true;
    }
    else {
      this.IsValidSecurityCode = false;
      return false;
    }
  }
  ValidateCreditCardExpirationDate() {
    let today;
    let exMonth = this.paymentForm.controls['SelectedExpirationDateMonth'].value.Value - 1;
    let exYear = this.paymentForm.controls['SelectedExpirationDateYear'].value.Value;
    today = new Date();
    if (exMonth == today.getMonth()) {
      let expireDay;
      expireDay = new Date();
      let expireDayTotal = new Date(exYear, exMonth, 0).getDate() - 3;
      expireDay.setFullYear(exYear, exMonth, expireDayTotal);
      if (expireDay < today) {
        this.Errors = [`The credit card entered is near expiration and will not be charged by our system until after it has expired. Please enter new credit card details to continue.`]
        return false;
      }
    }
    return true;
  }

  OnPlaceOrderChange() {
    if (this.ValidateName() === true && this.ValidateCardNumber() === true
      && this.ValidateSecurityCode() === true && this.ValidateCreditCardExpirationDate() == true) {
      if (this.CartItemsList.length <= 0) {
        this.Errors = [appMessages.CartEmpty];
      } else {
        this.ShowError = true;
        this.shoppingService.PlaceOrder(this.paymentForm.value)
          .subscribe(
            (response) => {

              if (!response.Error) {
                this.helperService.setToLocalStorage(appVariables.successOrderResponse, JSON.stringify(response));
                this.shoppingService.setCartItems([]);
                this.router.navigate(['../ordercomplete'], { relativeTo: this.route });
              } else {
                this.Errors = response.Error;
                this.ShowError = false;
              }
            },
            (error) => {
              this.Errors = JSON.parse(error._body).Error; // [appMessages.CommonError];
              this.ShowError = false;
            }
          );
      }
    }

  }


  OnMonthChange(checkEvent) {
    // this.CheckFormData();
    // this.paymentForm.controls['SelectedExpirationDateYear'].reset();
    this.CurrentDate = new Date();
    if (checkEvent != null) {
      if (checkEvent.Value < (this.CurrentDate.getMonth() + 1)) {
        for (let i = 0, len = this.YearList.length; i < len; i++) {
          if (this.YearList[i].Value === this.CurrentDate.getFullYear()) {
            this.YearList[i].Disabled = true;
          }
        }
      } else {
        for (let i = 0, len = this.YearList.length; i < len; i++) {
          this.YearList[i].Disabled = false;
        }
      }
    } else {
      for (let i = 0, len = this.YearList.length; i < len; i++) {
        this.YearList[i].Disabled = false;
      }
    }
  }


  OnYearChange(checkEvent) {
    // this.CheckFormData();
    // this.paymentForm.controls['SelectedExpirationDateMonth'].reset();
    this.CurrentDate = new Date();
    if (checkEvent != null) {
      if (checkEvent.Value === this.CurrentDate.getFullYear()) {
        for (let i = 0, len = this.MonthList.length; i < len; i++) {
          if (this.MonthList[i].Value < (this.CurrentDate.getMonth() + 1)) {
            this.MonthList[i].Disabled = true;
          }
        }
      } else {
        for (let i = 0, len = this.MonthList.length; i < len; i++) {
          this.MonthList[i].Disabled = false;
        }
      }
    } else {
      for (let i = 0, len = this.MonthList.length; i < len; i++) {
        this.MonthList[i].Disabled = false;
      }
    }
  }

  clearErrorMessage() {
    this.Errors = [];
  }


}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/payment/payment.component.ts